var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("c-tab", {
        ref: "ctomissTab",
        attrs: {
          type: "horizon",
          inlineLabel: true,
          dense: true,
          height: _vm.tabHeight,
          tabItems: _vm.tabItems,
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (tab) {
              return [
                _c(tab.component, {
                  tag: "component",
                  attrs: {
                    popupParam: _vm.popupParam,
                    plan: _vm.plan,
                    contentHeight: _vm.contentHeight,
                  },
                  on: {
                    "update:popupParam": function ($event) {
                      _vm.popupParam = $event
                    },
                    "update:popup-param": function ($event) {
                      _vm.popupParam = $event
                    },
                    "update:plan": function ($event) {
                      _vm.plan = $event
                    },
                  },
                }),
              ]
            },
          },
        ]),
        model: {
          value: _vm.tab,
          callback: function ($$v) {
            _vm.tab = $$v
          },
          expression: "tab",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }